import { render } from "./Newpassword.vue?vue&type=template&id=03416014&scoped=true&bindings={\"hideHeading\":\"props\",\"redirect\":\"props\",\"csrf\":\"setup\",\"changeMessage\":\"setup\",\"validation\":\"setup\",\"validations\":\"setup\",\"checkConfirmField\":\"setup\",\"state\":\"setup\",\"user\":\"setup\",\"reset\":\"setup\",\"registerPath\":\"setup\",\"isDisabledNextBtn\":\"setup\"}"
import script from "./Newpassword.vue?vue&type=script&lang=ts"
export * from "./Newpassword.vue?vue&type=script&lang=ts"

import "./Newpassword.vue?vue&type=style&index=0&id=03416014&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-03416014"

export default script